<template>
	<div class="manifesto-component">
		<button class="btn btn-primary btn-sm" ref="btnShowManifesto" @click="showManifestoLocal" v-show="false">Buscar Manifesto</button>
		<div v-if="!searchingManifesto">
			<div v-if="objectManifesto.id > 0">
				{{ objectManifesto.barcode }} - <span :class="'text-' + objectManifesto.transport.color">{{ objectManifesto.transport.name }}</span>
				<small class="float-right"><i>actualización: {{objectManifesto.created_at}}</i></small>
				<small class="float-right"><i>creación: {{objectManifesto.created_at}}</i> - </small> 
				<div class="table-responsive">
					<table class="table table-sm table-12">
						<thead>
							<tr>
								<th class="text-center">#</th>
								<th class="text-center">ID Envio</th>
								<th>Envia a:</th>
								<th>Dirección</th>
								<th>Comuna</th>
								<th class="text-center">Telefono</th>
								<th class="text-center">Bultos</th>
								<th class="text-center">Peso</th>
								<th class="text-center">Cta Cte</th>
								<th class="text-center">OF</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in listShippingsFilter" :key="index">
								<td class="text-center">{{ index + 1 }}</td>
								<td class="text-center">{{ item.id }}</td>
								<td>{{ item.sendto }}</td>
								<td>{{ item.address }}</td>
								<td>{{ item.comuna }}</td>
								<td class="text-center">{{ item.phone }}</td>
								<td class="text-center">{{ item.packages }}</td>
								<td class="text-center">{{ item.weight }}</td>
								<td class="text-center">
									<i class="fas fa-check text-success" v-if="item.paid_shipping == 1"></i>
									<i class="fas fa-times text-danger" v-else></i>
								</td>
								<td class="text-center">
									<span class="text-warning" title="Sin asignar" v-if="(item.freight_order == '' || item.freight_order == null)">?</span>
									<span v-else>{{ item.freight_order }}</span>
								</td>
								<td>
									<i class="fas fa-minus-circle text-danger pointer" v-if="item.freight_order.trim() == ''" @click="removeManifestoShipping(item)"></i>
								</td>
							</tr>
						</tbody>
						<tfoot>
							<tr>
								<td colspan="6"></td>
								<td class="text-center">{{ totalPackages }}</td>
								<td class="text-center">{{ totalWeight }}</td>
							</tr>
						</tfoot>
					</table>
				</div>
			</div>
		</div>
		<div v-else class="text-center">
			Estamos buscando el Manifiesto Nº {{ id }}
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import manifesto from '@/mixins/manifestos'

	export default {
		name: 'ManifestoComponent',
		mixins: [axiosAction, errors, mixin, manifesto],
		props: ['id'],
		data() {
			return {
			}			
		},
		components: {
		},
		computed: {
			listShippingsFilter() {
				let list = this.objectManifesto.shippings
				return list
			},
			totalPackages() {
				let total = this.listShippingsFilter.reduce(function(a, b) { 
                                let c = parseInt(b.packages)
                                return a + c
                            }, 0);
				return total
			},
			totalWeight() {
				let total = this.listShippingsFilter.reduce(function(a, b) { 
                                let c = parseFloat(b.weight)
                                return a + c
                            }, 0);
				return total
			},
		},
		methods: {
			deleteListShippingManifestoShippingLocal(shippingId, manifestoId) {
				let index = this.objectManifesto.shippings.map(e => parseInt(e.shipping_id)).indexOf(parseInt(shippingId))
				if(index > -1) {
					if(parseInt(this.objectManifesto.id) == parseInt(manifestoId)) {
						return this.objectManifesto.shippings.splice(index, 1)
					}
				}
				return false
			},
			deleteManifestoShippingResultLocal(response) {
				this.deleteListShippingManifestoShippingLocal(response.data.shipping_id, response.data.manifesto_id)
				this.$emit('actionDeleteManifestoShipping', response)
			},
			initComponentLocal() {
			},
			removeManifestoShipping(item) {
				if(confirm('Está a punto de borrar el envio Nº ' + item.id + ' de '+ item.sendto + ' del manifiesto ' + this.objectManifesto.name + '(' + this.objectManifesto.id +')\n¿Quiere continuar?')) {
					this.deleteManifestoShipping(this.objectManifesto.id, item.id)
				}
			},
			resultAxiosLocal(responseLocal, response) {
				switch(responseLocal) {
					case 'deleteManifestoShippingResult': this.deleteManifestoShippingResult(response); break;
					case 'showManifestoResult': this.showManifestoResult(response); break;
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
				this.$emit('hideLockScreen')
			},
			showManifestoLocal() {
				if(this.id > 0) {
					this.showManifesto(this.id)
				}
			},
			showManifestoResultLocal(response) {},
			updateStatusManifestoLocal(response) {}
		},
		mounted () {
			this.initComponentLocal()
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
